// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[par-configuration-health-check]', (element) => {
  up.layer.open({ document: element.outerHTML, target: '.par-configuration--heath-check', mode: 'modal' })
})
